import _ from 'lodash';

// Note: the delay values here need to match the values in .css to avoid cutting off the animations
export const animationDelayDefault = 400;

const simpleAnimationMap = {
    none: {},
    highlight: {
        classNames: 'highlight',
        timeout: {enter: animationDelayDefault},
        exit: false
    },
    insert: {
        classNames: 'insert',
        timeout: {enter: animationDelayDefault, exit: animationDelayDefault / 2}
    },
    reveal: {
        classNames: 'reveal',
        transitionWrapper: 'reveal_base',
        timeout: animationDelayDefault
    }
};

/**
 * Maps a named component to actual component class (and optional props)
 * Useful for json configuration definitions
 *
 * @param {string} name - The name of the animation to look up
 * @returns {Object} - The properties for the named animation
 */
export function resolveAnimationFromName(name) {
    // If alias is an object or function, just return its value
    if (_.isObject(name) || _.isFunction(name)) {
        return name;
    }
    return simpleAnimationMap[name] || simpleAnimationMap.none;
}
